import ErrorIcon from '@mui/icons-material/Error'
import { Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'

type SearchErrorStateProps = ComponentProps<'div'> & {
  onRetry?: () => void
}

export function SearchErrorState({ onRetry, ...props }: SearchErrorStateProps) {
  const t = useTranslations('SearchErrorState')

  return (
    <div
      {...props}
      className={`flex flex-col items-center justify-center gap-6 rounded-xl bg-error-light bg-opacity-30 px-6 py-12 ${props.className ?? ''}`}
    >
      <div className="flex shrink-0 flex-col items-start">
        <div className="flex w-full items-center justify-center gap-1.5">
          <ErrorIcon color="error" sx={{ fontSize: 16 }} />
          <Typography variant="h6" color="error">
            {t('title')}
          </Typography>
        </div>
        <Typography
          variant="body1"
          className="w-full whitespace-pre-wrap text-center font-sans text-base font-normal leading-6 text-mydra-black"
        >
          {t('description')}
        </Typography>
      </div>
      <Button variant="contained" onClick={onRetry}>
        {t('retry')}
      </Button>
    </div>
  )
}
